import angular from "angular"

const templateUrl = require("ngtemplate-loader!html-loader!./ayuda.component.html")

angular.module("appModule").component("ayuda", {
  templateUrl: templateUrl,
  controller: function AyudaController() {
    var self = this

    self.links = [
      {
        nombre: "manual",
        url: ""
      },
      {
        nombre: "video 1",
        url: ""
      }
    ]
  }
})
